export default __webpack_public_path__ + "static/media/yofi-logo.c21251af.png";